export default __webpack_public_path__ + "static/media/user3.9c17451c.png";